export type Filter = {
  name: string;
  value: string;
  displayName: string;
  detail?: string;
  isSelected?: boolean;
};

export enum FilterKindEnum {
  Events = 'events',
  SpecificPeople = 'specificpeople',
  Locations = 'locations',
  Artists = 'artists',
  Collections = 'collections',
}

export type FilterGroup = {
  kind: FilterKindEnum;
  subHeader?: string;
  filters: Array<Filter>;
};

export type FilterGroups = Array<FilterGroup>;

export type Filters = {
  [FilterKindEnum.Events]: Array<Filter>;
  [FilterKindEnum.SpecificPeople]: Array<Filter>;
  [FilterKindEnum.Locations]: Array<Filter>;
  [FilterKindEnum.Artists]: Array<Filter>;
};
